// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { default as dayjs } from "dayjs";
import {
  GridColDef,
  GridActionsCellItem,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar, StatusBarUser, ApiCredentialsModal } from "../../atoms";
import {
  IUser,
  useGetUserList,
  useDeleteUser,
  DeleteUserRequest,
  useForgotPassword,
  useAuthorization,
  useGetMerchantStatusList,
  useSendApiUserCredentials
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import { useUserInfo } from "../../../store/User.state";


function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;
  return <>{value && <StatusBarUser status={value} />}</>;
}

export const UserListingTable = () => {
  const theme = useTheme();
  const [userInfo] = useUserInfo();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { mutate: forgotPassword } = useForgotPassword();
  const [queryOptions, setQueryOptions] = React.useState({});
  const [showInternalUsersOnly, setShowInternalUsersOnly] = useState(false);
  const [tableData, setTableData] = useState<PagingResponse<Array<IUser>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const navigate = useNavigate();
  const { mutate: getUserList, isLoading } = useGetUserList();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  const { mutate: userDelete, isLoading: isDeleteLoading } = useDeleteUser();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});

  const { mutate: sendApiUserCredentials, isLoading: isSendApiUserCredentialsLoading } = useSendApiUserCredentials();

  const [isApiModalOpen, setIsApiModalOpen] = useState(false);
  const [apiUserDetail, setApiUserDetail] = useState(null);
  const [notificationType, setNotificationType] = useState('none');
  const [notificationEmail, setNotificationEmail] = useState('');
  const [notificationPhone, setNotificationPhone] = useState('');

  const handleApiModalClose = () => {
    setIsApiModalOpen(false);
    setApiUserDetail(null);
    setNotificationType('none');
    setNotificationEmail('');
    setNotificationPhone('');
  };

  const handleSendUserInformation = () => {

    let request: ISendApiUserCredentialsRequest = {
      email: notificationEmail,
      notificationType: notificationType,
      phoneNumber: notificationPhone,
      password: apiUserDetail.password,
      userId: apiUserDetail?.id,
      username: apiUserDetail.username
    }

    sendApiUserCredentials(request, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          handleApiModalClose();
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: "Kullanıcı bilgileri başarıyla gönderildi!",
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      }
    })
  }

  useEffect(() => {
    const savedFilter = localStorage.getItem("userFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);


  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantStat: { value: string; key: number }) => {
        return {
          label: merchantStat?.key,
          value: `${merchantStat?.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  useEffect(() => {
    const requestPayload: any = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: Number(userInfo.merchantId),
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    // İç kullanıcı filtresi aktifse payload'a ekle
    if (showInternalUsersOnly) {
      requestPayload.isInternalUser = true;
    }

    getUserList(requestPayload, {
      onSuccess: (data) => {
        if (data?.isSuccess) {
          setTableData(data?.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data?.data);
          setSnackbar({
            severity: "error",
            description: data?.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
    setShouldRefresh(false);
  }, [
    getUserList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    showInternalUsersOnly,
  ]);


  const handleResetPassword = React.useCallback(
    (tempUser: IUser) => () => {
      forgotPassword({
        email: tempUser.email,
        phoneNumber: `0${tempUser.phoneNumber}`,
      }, {
        onSuccess: (data) => {
          if (data?.isSuccess) {

            if (tempUser.userType === 3) {
              setApiUserDetail({
                ...tempUser,
                password: data?.data,
                phoneNumber: tempUser?.phoneNumber
              });
              setIsApiModalOpen(true);
            }
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              description: data?.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        }
      },);
      setShouldRefresh((prev) => !prev);
    },
    [forgotPassword]
  );

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    const request: any = {
      size: model.pageSize,
      page: model.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: Number(userInfo.merchantId),
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      request[queryOptions.field] = queryOptions.value;
    }

    if (showInternalUsersOnly) {
      request.isInternalUser = true;
    }

    getUserList(
      request,
      {
        onSuccess: (data) => {
          if (data?.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const editRow = React.useCallback(
    (user: IUser) => () => {
      navigate("/user-management/user-identification", { state: user });
    },
    [navigate]
  );

  const deleteRow = React.useCallback(
    (user: IUser) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(user.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteUserRequest = { id: selectedRowId };

    userDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh((prevState) => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  const columns: GridColDef<IUser, any, any>[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          // Eğer satır "PASSIVE" ise hiçbir aksiyon gösterme
          if (params.row.status === 'PASSIVE') {
            return [];
          }

          if (Number(userInfo.userType) === 2 && params.row.userType === 3) {
            return [
              <GridActionsCellItem
                label="Parolayı Sıfırla"
                onClick={handleResetPassword(params.row)}
                showInMenu
              />,
            ];
          }

          let actions = [];

          if (showUpdate) {
            actions.push(
              <GridActionsCellItem
                label="Düzenle"
                onClick={editRow(params.row)}
                showInMenu
              />
            );
          }

          if (showDelete) {
            actions.push(
              <GridActionsCellItem
                label="Sil"
                onClick={deleteRow(params.row)}
                showInMenu
              />
            );
          }

          actions.push(
            <GridActionsCellItem
              label="Parolayı Sıfırla"
              onClick={handleResetPassword(params.row)}
              showInMenu
            />
          );

          return actions;
        },

      },
      { field: "fullName", headerName: "Adı Soyadı", width: 200 },
      { field: "userTypeDesc", headerName: "Kullanıcı Tipi", width: 180 },
      {
        field: "roles",
        headerName: "Kullanıcı Rolü",
        width: 300,
        renderCell: (params) => {
          return params?.value?.map((role: any) => role?.value).join(', ');
        }
      },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 100,
        filterOperators: [createStatusOperator(merchantStatuses)],
      },
      { field: "email", headerName: "E Posta", width: 300 },
      { field: "phoneNumber", headerName: "Telefon", width: 180 },
      { field: "createDate", headerName: "Oluşturma T.", width: 200, renderCell: (params) => { return dayjs(params.value).format("YYYY-MM-DD HH:mm:ss") } },
      { field: "merchantId", headerName: "Üye İşyeri No", width: 180 },
      { field: "merchantName", headerName: "Üye İşyeri Adı", width: 400 },
      { field: "parentMerchantId", headerName: "Bağlı Olunan İşyeri No", width: 180 },
      { field: "parentMerchantName", headerName: "Bağlı Olunan İşyeri Adı", width: 400 },
    ];
  }, [deleteRow, editRow, handleResetPassword, showDelete, showUpdate, userInfo.userType]);
  const keyMapping = {
    status: "Durum",
  };
  const onSave = () => {
    const requestPayload: any = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: Number(userInfo.merchantId),
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    if (showInternalUsersOnly) {
      requestPayload.isInternalUser = true;
    }

    getUserList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          function fieldValue(data) {
            return data?.map((item) => {
              let rolesValue = item?.roles
                ? item?.roles.map((role) => role?.value || "").join(", ")
                : "";

              return {
                "Ad Soyad": item?.fullName,
                "Kullanıcı Tipi": item?.userTypeDesc,
                [keyMapping["status"]]: item?.status,
                "Email": item?.email,
                "Telefon": item?.phoneNumber,
                "Üye İşyeri No": item?.merchantId,
                "Üye İşyeri Adı": item?.merchantName,
                "Bağlı Olunan İşyeri No": item?.parentMerchantId,
                "Bağlı Olunan İşyeri Adı": item?.parentMerchantName,
                "Kullanıcı Rolü": rolesValue,
                "Oluşturma Tarihi": item?.createDate,
              };
            });
          }
          const refactoredData = fieldValue(data?.data?.result);
          downloadExcel(refactoredData || [], "Kullanıcı Listesi", keyMapping);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem("userFilter");
      return setQueryOptions({});
    }
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem("userFilter", JSON.stringify(queryParams));
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);

  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;


  const hasLoading = isLoading || isDeleteLoading || isSendApiUserCredentialsLoading;

  const rowsToShow = useMemo(() => {
    const rows = tableData?.result || [];
    if (!showInternalUsersOnly) return rows;

    return rows.filter((row: any) => Boolean(row?.IsInternalUser ?? row?.isInternalUser));
  }, [tableData?.result, showInternalUsersOnly]);

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>

        <>
          <Table
            filterKey="userFilter"
            columnVisibilityConfigKey="userColumnVisibilityKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            showInternalUsersToggle={true}
            internalUsersToggleValue={showInternalUsersOnly}
            onInternalUsersToggleChange={(val) => setShowInternalUsersOnly(Boolean(val))}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            // disableColumnMenu
            rows={rowsToShow}
            columns={columns}
            getRowClassName={(params) => {
              if (params.row.status === "PASSIVE") return "blocked-row";
              if (params.row.status === "BLOCKED") return "pasive-row";
              return "";
            }}
            exportFileName="Kullanıcı Listesi"
            onSave={() => onSave()}
          />
          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>

      </Stack>

      <ApiCredentialsModal
        onClose={handleApiModalClose}
        isOpen={isApiModalOpen}
        apiEmail={apiUserDetail?.email}
        apiPassword={apiUserDetail?.password}
        notificationType={notificationType}
        setNotificationType={setNotificationType}
        notificationEmail={notificationEmail}
        setNotificationEmail={setNotificationEmail}
        notificationPhone={notificationPhone}
        setNotificationPhone={setNotificationPhone}
        handleSendUserInformation={handleSendUserInformation}
        apiUserPhoneNumber={apiUserDetail?.phoneNumber}
      />
    </>
  );
};
